import styles from "./waiting-next-game.module.css";
import waitingNextGame from "illustrations/waiting-next-game.png";
import { useTranslation } from "react-i18next";

const WaitingNextGame = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.wrapper}>
      <img
        src={waitingNextGame}
        width="100%"
        alt="waiting next game"
        data-testid="data-test-waiting-next-game-image"
      />
      <div className={styles.content}>
        <h2 className="title-1-variant-low">
          {t("dashboard.waiting-next-game.title")}
        </h2>
        <p className="title-3-variant">
          {t("dashboard.waiting-next-game.subtitle")}
        </p>
      </div>
    </div>
  );
};

export default WaitingNextGame;
